import { getLocalStorage } from './index'

/**
 * 安全读取 localStorage：
 * - localStorage 抛错（隐私模式 / disabled）时返回 fallback
 * - 值被损坏（例如用户手动改写为无效字符串）时返回 fallback
 */
export function getLocalStorageSafe<T>(key: string, fallback: T, validate: (v: unknown) => v is T): T {
	try {
		const raw = getLocalStorage(key)
		return validate(raw) ? raw : fallback
	} catch {
		return fallback
	}
}

/**
 * 安全读取 boolean 值。localStorage 存的是字符串 'true' / 'false'，其它值都退回 fallback。
 */
export function getLocalStorageBoolean(key: string, fallback: boolean): boolean {
	try {
		const raw = getLocalStorage(key)
		if (raw === 'true') return true
		if (raw === 'false') return false
		return fallback
	} catch {
		return fallback
	}
}
